import React from 'react';
import styled from 'styled-components';
import CellContainer from '../CellContainer';
import CountryLabel from '../../CountryLabel';

const EmptyValue = styled.div`
  height: 100%;
  opacity: 0.4;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    border-top: 2px solid ${(props) => props.theme.colors.dark};
    width: 12px;
  }
`;

const Cell = ({ value, ...otherProps }) => (
  <CellContainer {...otherProps}>
    {value ? (
      <CountryLabel name={value.value} country={value.country} />
    ) : (
      <EmptyValue>
        <div />
      </EmptyValue>
    )}
  </CellContainer>
);

export default Cell;
